<div class="title">{{ tournament.name }}</div>
<ng-container *ngIf="tournament.settings.type !== tournamentTypes.fiba">
  <mtg-chips *ngIf="tournament.status !== tournamentStatuses.closed">
    Проходит {{ getTourTitle(gamesStages.currentTour) }}
  </mtg-chips>

  <mtg-chips *ngIf="tournament.status === tournamentStatuses.closed">Завершен</mtg-chips>

  <div class="link-tabs" *ngIf="rounds.length > 0">
    <a
      *ngFor="let item of rounds"
      [routerLink]="[]"
      [queryParams]="getRoundQueryParams(item.id)"
      queryParamsHandling="merge"
      (click)="setRound(item)"
      [ngClass]="{active: selectedRound.id === item.id}"
    >{{ item.name }}</a>
  </div>

  <div class="standings-type" *ngIf="tournament.sport.isRugby()">
    <a [ngClass]="{active: !isChess}" (click)="chess(false)"><mtg-svg-icon icon="icons-list"></mtg-svg-icon></a>
    <a class="chess" (click)="chess(true)" [ngClass]="{active: isChess}"><mtg-svg-icon icon="icons-chess"></mtg-svg-icon></a>
  </div>

  <ng-container *ngIf="selectedRound.divisions.length > 0">
    <ng-container *ngFor="let division of selectedRound.divisions">
      <div class="division" *ngIf="!divisionId || division.id === divisionId">
        <div class="division-header" [ngStyle]="{backgroundImage: 'url(' + division.cover.path + ')'}">
          <div class="name">{{ division.name }}</div>
          <a
            [routerLink]="[]"
            [queryParams]="getDivisionQueryParams(division.id)"
            queryParamsHandling="merge"
            class="btn-detail"
            *ngIf="!divisionId"
          >Перейти</a>
        </div>
        <div class="content">
          <ng-container *ngIf="selectedRound.type === roundTypes.playoff">
            <div class="playoff" *ngFor="let playoff of divisionPlayoffs[division.id]">
              <mtg-tournament-playoff-widget
                [playoff]="playoff"
                [sport]="tournament.sport"
              ></mtg-tournament-playoff-widget>
            </div>
          </ng-container>

          <ng-container *ngIf="selectedRound.type === roundTypes.group">
            <mtg-tournament-standings
              *ngFor="let group of divisionGroups[division.id]"
              [tournament]="tournament"
              [tournamentRound]="selectedRound"
              [titleVisible]="divisionGroups[division.id].length > 1"
              [group]="group"
              [isChess]="isChess"
            ></mtg-tournament-standings>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="selectedRound.divisions.length === 0">
    <ng-container *ngIf="selectedRound.type === roundTypes.playoff">
      <div class="playoff" *ngFor="let playoff of playoffs">
        <mtg-tournament-playoff-widget
          [playoff]="playoff"
          [sport]="tournament.sport"
        ></mtg-tournament-playoff-widget>
      </div>
    </ng-container>

    <ng-container *ngIf="selectedRound.type === roundTypes.group">
      <mtg-tournament-standings
        *ngFor="let group of groups"
        [tournament]="tournament"
        [tournamentRound]="selectedRound"
        [group]="group"
      ></mtg-tournament-standings>
    </ng-container>
  </ng-container>
  <ng-container *ngFor="let court of courts">
    <mtg-games-slider
      *ngIf="court.activeGamesCount > 0"
      [court]="court"
      [tournamentId]="tournament.id"
      [sport]="tournament.sport"
      [roundId]="selectedRound.id"
      [divisionId]="selectedRound.divisions.length > 0 && divisionId"
      [statuses]="[gameStatuses.open, gameStatuses.in_progress]"
    ></mtg-games-slider>
  </ng-container>

  <mtg-games-slider
    sliderTitle="Результаты игр"
    [tournamentId]="tournament.id"
    [statuses]="[gameStatuses.closed]"
    [sport]="tournament.sport"
    [roundId]="selectedRound.id"
    [divisionId]="selectedRound.divisions.length > 0 && divisionId"
  ></mtg-games-slider>
</ng-container>
<router-outlet></router-outlet>
<mtg-league-about-block></mtg-league-about-block>
